<template>
  <div>
    <div class='top'>
      <div class='top-l'>我的班级</div>
      <!--<div class='top-r'>-->
          <!--<div class="top-rcon">-->
            <!--<input placeholder="搜索" type="text" />-->
          <!--</div>-->
        	<!--<img src="~@/assets/images/search.png">-->
      <!--</div>-->
    </div>

    <div class='mybj' v-for="item in this.lists.arr">
      <div class='mybj-l'>
        <router-link
                target="_blank"
                :to="{path:'/sonclasslist',query:{id:item.class_id}}">
        <img :src="item.logo">
        </router-link>
      </div>
      <div class='mybj-r'>
        <div class='mybj-r-t'>
            <router-link
                    tag="div"
                    class='mybj-r-t-l'

                    :to="{path:'/sonclasslist',query:{id:item.class_id}}"
            >
            {{ item.classname }}</router-link>
          <router-link
                  tag="div"

                  :to="{path:'/sonclasslist',query:{id:item.class_id}}"
          >
         更多
          </router-link>
        </div>
        <div class='mybj-r-b'>

          <div class='mybj-r-bcon' v-for="vo in item.course" @click="gocoursedetail(vo.course_id)">
            <router-link target="_blank"
                    :to="{path:'/detailsclass',query:{id:vo.course_id}}">
            <div class='mybj-r-bcon-t'>
              <img :src="vo.course_imgUrl">
            </div>
            <div class='mybj-r-bcon-b'>
              {{ vo.course_name }}
            </div>
            </router-link>
          </div>

        </div>

      </div>
    </div>


    <div class="pageing"  v-if="lists.arr != undefined && lists.arr.length != 0 && lists.total_pages>1">
      <span @click="pageindex">首页</span>
      <el-pagination
        small
        layout="prev, pager, next"
        prev-text="上一页"
        next-text="下一页"
        :background="true"
        :total="lists.total_pages==null?1:lists.total_pages"
        :page-size="1"
        @current-change="currentchange"
        :current-page="page"
      ></el-pagination>
      <span @click="pageend">尾页</span>
    </div>
  </div>
</template>

<script>
import { Pagination, Tabs, TabPane, Message } from "element-ui";
import utilFile from "@/ace/ace.js";
export default {
  components: {
    [Pagination.name]: Pagination,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Message.name]: Message,
  },
  data () {
    return {
      page: 1,
      lists:{}
    };
  },
  watch: {

    page (newvalue) {
      this.page = newvalue;
      this.get_classes();
    }
  },
  methods: {

    get_classes() {
      var data = utilFile.encrypt(
          JSON.stringify({
            page: this.page
          })
      );
  var that =this;
      this.$axios({
        method: "post",
        url: `/api/user.myclasslist?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 999) {
          this.$router.push({
            path: "/logins"
          });
        } else {

          if (res.data.data != undefined) {
            var totaldata = JSON.parse(utilFile.decrypt(res.data.data));
            console.log(totaldata);
            that.lists = totaldata;
          }

        }
      });
    }

    ,pageindex() {
      this.page = 1;
    }
    ,currentchange(page) {
      this.page = page;
    }
    ,pageend() {
      this.page = this.lists.total_pages;
    },

  },
  mounted () {
    this.get_classes();
  }
};
</script>

<style scoped>
.top {
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}
.top-l {
  height: 65px;
  line-height: 65px;
  color: #409eff;
  border-bottom: 1px solid #409eff;
}
.top-r {
  height: 30px;
  width: 250px;
  border: 1px solid #409eff;
  border-radius: 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.top-r img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  margin-left: 10px;
}
.top-rcon {
  width: 200px;
  height: 100%;
}
.top-rcon input {
  width: 200px;
  height: 100%;
}
.mybj {
  width: 100%;
  height: 260px;
  border-radius: 20px;
  border: 1px solid #eee;
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
}
.mybj-l {
  width: 260px;
  height: 100%;
  border-right: 1px solid #eee;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mybj-l img {
  width: 100%;
  height: 100%;
}
.mybj-r {
  width: 660px;
  height: 100%;
  padding-right: 18px;
  box-sizing: border-box;
}
.mybj-r-t {
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #38a0ff;
}
.mybj-r-t-l {
  /*width: 82px;*/
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  /*border: 1px solid #38a0ff;*/
  /*border-radius: 10px;*/
}
.mybj-r-b {
  width: 100%;
  height: 180px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
}
.mybj-r-b::after {
  content: "";
  width: 210px;
}
.mybj-r-bcon {
  width: 210px;
  height: 180px;
}
.mybj-r-bcon-t {
  width: 210px;
  height: 100px;
  border-radius: 10px;
  overflow: hidden;
}
.mybj-r-bcon-t img {
  width: 210px;
  height: 100px;
  border-radius: 10px;
}
.mybj-r-bcon-b {
  width: 210px;
  padding-top: 15px;
  font-size: 14px;
  color: #333333;
}
</style>